import ParticipatePage from "./ParticipatePage.jsx";

export default function ParticipateEntry() {
  return <ParticipatePage />;
}
